import styled from '@emotion/styled';

export const DiscountBadge = styled.span`
  color: var(--colorUIGreen);
  border: 2px solid var(--colorUIGreen);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  align-self: flex-start;
`;

export const BookingComment = styled.span`
  display: inline-block;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid var(--colorBlueGray200);
  font-size: 12px;
  color: var(--colorBlueGray200);
  padding: 2px 8px;
  margin-top: 16px;
  max-width: 100%;
  font-weight: 600;
`;

export const IconText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--colorBlueGray500);
  font-size: 12px;
  margin-bottom: 4px;
`;
